'use client'

import { BaseQueryFn, fetchBaseQuery, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'

import { getRuntimeConfig } from '../config/runtimeConfig'

// Wrapper que resuelve BASE_URL en tiempo de request (no en tiempo de módulo).
// Esto permite que el mismo bundle sirva a EC/PE y a QA/UAT/PROD sin rebuild.
const crearBaseQuery = (forceRefresh: boolean): ReturnType<typeof fetchBaseQuery> =>
  fetchBaseQuery({
    baseUrl: getRuntimeConfig().BASE_URL,
    prepareHeaders: async (headers) => {

      const { authHeader } = await import('@/common/helpers/authHeader')
      const { accessToken } = await authHeader(forceRefresh)

      if (accessToken) {
        headers.set('Authorization', `Bearer ${accessToken}`)
      }
      headers.set('Content-Type', 'application/json')

      return headers
    },
  })

export const baseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError,
  object,
  FetchBaseQueryMeta
> = async (args, api, extraOptions) => {
  const result = await crearBaseQuery(false)(args, api, extraOptions)

  // 401 = la API rechazó el token (rotado, desfase de reloj). UN reintento con token
  // fresco; si vuelve a fallar se propaga. Nunca en bucle.
  // 403 NO se reintenta: es falta de app role en Entra, reloguear no lo arregla.
  if (result.error?.status !== 401) {
    return result
  }

  return crearBaseQuery(true)(args, api, extraOptions)
}
